module.exports = __webpack_public_path__ + "static/banner-mb-01-8d1aa9586303edf89368617db8718123.jpg";